import { AxiosRequestConfig } from "axios";
import { Recurso } from "../../../modules/dashboard/types";
import api from "../api-instance";

const ROUTE = "/Resource";

export async function getMenuResourcesByClientId(id: string): Promise<Recurso[]> {
      const config: AxiosRequestConfig = {
        params: {
          id: id,
        },
      };
  const result = await api.get(`${ROUTE}/menu-resources/byClientId`, config);
  return result.data.resources;
}